export default class Param {
    constructor(){

        this.breakpoint = 750;
        this.displayType = ( window.innerWidth>this.breakpoint)?"pc":"sp";

        this.tabPage = ["business", "faq"];
        this.businessTabPage = ["business"];
        this.togglePage = ["faq"];
        this.newsSelectPage = ["news"];


    }
}
